
import ContactsBlock from '@/components/TheMain/components/ContactsBlock'
import CoolLightBox from "vue-cool-lightbox";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  name: 'Insider',
  components: {
    ContactsBlock,
  CoolLightBox
  },
  data() {
    return {
      images: [
        {url: '/images/M3000_Insider.jpg'}
      ],
      imageIndex: null,
      text: '        Ген <i>EGFR</i> расположен на 7 хромосоме и кодирует трансмембранный\n' +
        '        рецептор эпидермального фактора роста, обладающий тирозинкиназной\n' +
        '        активностью. В нативной конформации белка киназный домен обладает\n' +
        '        аутоингибирующей активностью, а аминокислотные замены, происходящие\n' +
        '        вследствие мутаций гена, нарушают ее и&nbsp;приводят к конститутивной\n' +
        '        активации белка. Такая активация рецептора и нижележащих сигнальных\n' +
        '        каскадов ингибирует апоптоз и стимулирует клеточную пролиферацию,\n' +
        '        ангиогенез, метастазирование, развитие и малигнизацию опухоли.\n' +
        '        Активирующие соматические мутации, ведущие к этим событиям, находятся в\n' +
        '        18, 19, 20, 21 экзонах гена <i>EGFR</i>. <br /><br />\n' +
        '        Гены <i>KRAS, NRAS</i> и <i>BRAF</i> человека кодируют\n' +
        '        ферменты-компоненты сигнального каскада RTK-RAS-RAF-MEK. В&nbsp;этом&nbsp;каскаде\n' +
        '        ГТФазы <i>KRAS</i> и <i>NRAS</i> являются активаторами серин-треониновой\n' +
        '        киназы <i>BRAF</i>, и взаимодействие этих белков регулирует пролиферацию\n' +
        '        и дифференцировку клеток. Дерегуляция работы каскада, в том числе в\n' +
        '        следствие мутаций в генах <i>KRAS</i>, <i>NRAS</i> и <i>BRAF</i> и\n' +
        '        последующей гиперактивации белков, приводит к формированию и\n' +
        '        малигнизации опухолей. В генах Ras такими мутациями являются нарушения в&nbsp;экзонах 2&nbsp;(c.12,&nbsp;c.13), 3&nbsp;(c.59,&nbsp;c.61), 4&nbsp;(c.117,&nbsp;c.146). В гене\n' +
        '        <i>BRAF</i> наиболее изученные и клинически значимые мутации происходят\n' +
        '        в экзоне 15 (c.600; мутация&nbsp;V600)&nbsp;– они повышают активность\n' +
        '        фермента в 500-700 раз.',
      mutations: [
        {
          expanded: false,
          gen: 'EGFR',
          ekzon: 'ex 18',
          coords: 'chr7:55174010-55174018',
          nulleoid: 'c.2156G>C',
          amino: 'p.G719A',

          inside: [
            {
              nulleoid: 'c.2155G>A',
              amino: 'p.G719S',
            },
            {
              nulleoid: 'c.2155G>T',
              amino: 'p.G719C',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 19',
          coords: 'chr7:55174769-55174781',
          nulleoid: 'c.2235_2249del15',
          amino: 'p.E746_A750delELREA',

          inside: [
            {
              nulleoid: 'c.2236_2250del15',
              amino: 'p.E746_A750delELREA',
            },
            {
              nulleoid: 'c.2240_2254del15',
              amino: 'p.L747_T751delLREAT',
            },
            {
              nulleoid: 'c.2239_2256del18',
              amino: 'p.L747_S752delLREATS',
            },
            {
              nulleoid: 'c.2238_2252del15',
              amino: 'p.L747_T751delLREAT',
            },
            {
              nulleoid: 'c.2239_2247delTTAAGAGAA',
              amino: 'p.L747_E749delLRE',
            },
            {
              nulleoid: 'c.2237_2251del15',
              amino: 'p.E746_T751>A',
            },
            {
              nulleoid: 'c.2237_2254del18',
              amino: 'p.E746_S752>A',
            },
            {
              nulleoid: 'c.2237_2255>T',
              amino: 'p.E746_S752>V',
            },
            {
              nulleoid: 'c.2238_2255del18',
              amino: 'p.E746_S752>D',
            },
            {
              nulleoid: 'c.2238_2248>GC',
              amino: 'p.L747_A750>P',
            },
            {
              nulleoid: 'c.2239_2258>CA',
              amino: 'p.L747_P753>Q',
            },
            {
              nulleoid: 'c.2240_2251del12',
              amino: 'p.L747_T751>S',
            },
            {
              nulleoid: 'c.2240_2257del18',
              amino: 'p.L747_P753>S',
            },
            {
              nulleoid: 'c.2239_2251>C',
              amino: 'p.L747_T751>P',
            },
            {
              nulleoid: 'c.2239_2248TTAAGAGAAG>C',
              amino: 'p.L747_A750>P',
            },
            {
              nulleoid: 'c.2236_2253del18',
              amino: 'p.E746_T751delELREAT',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 20',
          coords: 'chr7:55181306-55181316',
          nulleoid: 'c.2303G>T',
          amino: 'p.S768I',
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 20',
          coords: 'chr7:55181315-55181324',
          nulleoid: 'c.2310_2311insGGT',
          amino: 'p.D770_N771insG',
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 20',
          coords: 'chr7:55181372-55181381',
          nulleoid: 'c.2369C>T',
          amino: 'p.T790M',
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 20',
          coords: 'chr7:55181394-55181405',
          nulleoid: 'c.2390G>A',
          amino: 'p.C797Y',

          inside: [
            {
              nulleoid: 'c.2390G>C',
              amino: 'p.C797S',
            },
            {
              nulleoid: 'c.2389T>A',
              amino: 'p.C797S',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 21',
          coords: 'chr7:55191817-55191825',
          nulleoid: 'c.2573T>G',
          amino: 'p.L858R',
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex 21',
          coords: 'chr7:55191828-55191838',
          nulleoid: 'c.2582T>A',
          amino: 'p.L861Q',
        },
        {
          expanded: false,
          gen: 'KRAS',
          ekzon: 'ex2 c.12',
          coords: 'chr12:25245343-25245355',
          nulleoid: 'c.35G>A',
          amino: 'p.G12D',

          inside: [
            {
              nulleoid: 'c.34G>T',
              amino: 'p.G12C',
            },
            {
              nulleoid: 'c.35G>C',
              amino: 'p.G12A',
            },
            {
              nulleoid: 'c.34G>A',
              amino: 'p.G12S',
            },
            {
              nulleoid: 'c.34G>C',
              amino: 'p.G12R',
            },
            {
              nulleoid: 'c.36T>C',
              amino: 'p.G12G',
            },
            {
              nulleoid: 'c.36T>A',
              amino: 'p.G12G',
            },
            {
              nulleoid: 'c.36T>G',
              amino: 'p.G12G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex2 c.13',
          coords: 'c.38G>A',
          nulleoid: 'c.35G>A',
          amino: 'p.G13D',

          inside: [
            {
              nulleoid: 'c.37G>T',
              amino: 'p.G13C',
            },
            {
              nulleoid: 'c.37G>A',
              amino: 'p.G13S',
            },
            {
              nulleoid: 'c.37G>C',
              amino: 'p.G13R',
            },
            {
              nulleoid: 'c.38G>C',
              amino: 'p.G13A',
            },
            {
              nulleoid: 'c.38G>T',
              amino: 'p.G13V',
            },
            {
              nulleoid: 'c.39C>A',
              amino: 'p.G13G',
            },
            {
              nulleoid: 'c.39C>T',
              amino: 'p.G13G',
            },
            {
              nulleoid: 'c.39C>G',
              amino: 'p.G13G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.59',
          coords: 'chr12:25227339-25227351',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.176C>G',
              amino: 'p.A59G',
            },
            {
              nulleoid: 'c.35G>A',
              amino: 'p.G12D',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.61',
          coords: 'chr12:25227339-25227351',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.183A>C',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.182A>G',
              amino: 'p.Q61R',
            },
            {
              nulleoid: 'c.182A>T',
              amino: 'p.Q61L',
            },
            {
              nulleoid: 'c.183A>T',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.181C>A',
              amino: 'p.Q61K',
            },
            {
              nulleoid: 'c.182A>C',
              amino: 'p.Q61P',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.117',
          coords: 'chr12:25225705-25225721',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.351A>T',
              amino: 'p.K117N',
            },
            {
              nulleoid: 'c.351A>C',
              amino: 'p.K117N',
            },
            {
              nulleoid: 'c.349A>G',
              amino: 'p.K117E',
            },
            {
              nulleoid: 'c.350A>G',
              amino: 'p.K117R',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.146',
          coords: 'chr12:25225622-25225635',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.437C>T',
              amino: 'p.A146V',
            },
            {
              nulleoid: 'c.436G>C',
              amino: 'p.A146P',
            },
            {
              nulleoid: 'c.436G>T',
              amino: 'p.A146S',
            },
          ],
        },
        {
          expanded: false,
          gen: 'NRAS',
          ekzon: 'ex2 c.12',
          coords: 'chr1:114716119-114716131',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.35G>A',
              amino: 'p.G12D',
            },
            {
              nulleoid: 'c.34G>A',
              amino: 'p.G12S',
            },
            {
              nulleoid: 'c.34G>T',
              amino: 'p.G12C',
            },
            {
              nulleoid: 'c.35G>T',
              amino: 'p.G12V',
            },
            {
              nulleoid: 'c.35G>C',
              amino: 'p.G12A',
            },
            {
              nulleoid: 'c.34G>C',
              amino: 'p.G12R',
            },
            {
              nulleoid: 'c.36T>C',
              amino: 'p.G12G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex2 c.13',
          coords: 'chr1:114716119-114716131',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.38G>A',
              amino: 'p.G13D',
            },
            {
              nulleoid: 'c.37G>C',
              amino: 'p.G13R',
            },
            {
              nulleoid: 'c.38G>T',
              amino: 'p.G13V',
            },
            {
              nulleoid: 'c.37G>T',
              amino: 'p.G13C',
            },
            {
              nulleoid: 'c.37G>A',
              amino: 'p.G13S',
            },
            {
              nulleoid: 'c.38G>C',
              amino: 'p.G13A',
            },
            {
              nulleoid: 'c.39T>C',
              amino: 'p.G13G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.59',
          coords: 'chr1:114713918-114713906',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.175G>A',
              amino: 'p.A59T',
            },
            {
              nulleoid: 'c.176C>A',
              amino: 'p.A59D',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.61',
          coords: 'chr1:114713918-114713906',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.182A>G',
              amino: 'p.Q61R',
            },
            {
              nulleoid: 'c.181C>A',
              amino: 'p.Q61K',
            },
            {
              nulleoid: 'c.182A>T',
              amino: 'p.Q61L',
            },
            {
              nulleoid: 'c.183A>T',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.183A>C',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.182A>C',
              amino: 'p.Q61P',
            },
            {
              nulleoid: 'c.181C>G',
              amino: 'p.Q61E',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.117',
          coords: 'chr1:114709676-114709663',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.231G>T',
              amino: 'p.K117N',
            },
            {
              nulleoid: 'c.231A>G',
              amino: 'p.K117N',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.146',
          coords: 'chr1:114709587-114709576',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.436G>A',
              amino: 'p.A146T',
            },
            {
              nulleoid: 'c.437C>T',
              amino: 'p.A146V',
            },
          ],
        },
        {
          expanded: false,
          gen: 'BRAF',
          ekzon: 'ex15 c.600',
          coords: 'chr7:140753329-140753343',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.1799T>A',
              amino: 'p.V600E',
            },
            {
              nulleoid: 'c.1798_1799GT>AA',
              amino: 'p.V600K',
            },
            {
              nulleoid: 'c.1798_1799GT>AG',
              amino: 'p.V600R',
            },
            {
              nulleoid: 'c.1799_1800TG>AA',
              amino: 'p.V600E',
            },
          ],
        },
      ],
    }
  },

  head() {
    return {
      title: 'Инсайдер',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Наборы для скрининга мутаций в горячих точках генов EGFR, BRAF, NRAS и KRAS методом мутационно-специфической ПЦР-РВ',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            'Инсайдер, M3000, Инсайдер KRAS-2, Инсайдер NRAS-3, Инсайдер BRAF, тест система KRAS, тест система NRAS, тест система BRAF, kit KRAS, kit NRAS, kit BRAF, набор KRAS, набор NRAS, набор BRAF, мутация KRAS, мутация NRAS, мутация BRAF, R3002, R3009, R3010, R3011',
        },
      ],
    }
  },
  methods: {
    expandAll() {
      this.mutations.forEach((v) => (v.expanded = true))
    },
    hideAll() {
      this.mutations.forEach((v) => (v.expanded = false))
    },
  },
}
